// extracted by mini-css-extract-plugin
export default {"documents-list":"IIqzozOXNgo0J68","loader":"eORv_samGLjHHnj"};